import { useMemo } from "react";
import type { FigurinhaDaBiblioteca } from "@foto/shared";
import { VisorDeImagem } from "../../components/VisorDeImagem.js";

/**
 * O visor com zoom (roda, pinça, arrasto) de uma imagem da biblioteca, com o xadrez atrás.
 *
 * Passa por `versoes`, e não pela forma de imagem única, para o visor medir o arquivo que de fato carrega:
 * a derivada `tela` tem no máximo 1080 px, e o "100%" que o visor mostra tem de ser o dessa imagem, não o
 * da original de até 2048 px. A `mini` (já na página, da grade) aparece na hora, por baixo.
 */
export function VisorDaFigurinha({
  item,
  aoFechar,
}: {
  item: FigurinhaDaBiblioteca;
  aoFechar: () => void;
}) {
  const versoes = useMemo(
    () => [{ id: "unica", rotulo: item.nome, url: item.urls.tela, previa: item.urls.mini }],
    [item.nome, item.urls.tela, item.urls.mini],
  );
  return (
    <VisorDeImagem
      titulo={item.nome}
      alt={item.nome}
      versoes={versoes}
      fundo="xadrez"
      aoFechar={aoFechar}
    />
  );
}
